import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Layout, Button, message } from 'antd';
import { API_URL, LoadOptListResponse, LoadOptListResult, OPTinsData, UpdateOptResponse, UpdateOptResult } from "../constant";
import { ImportOutlined } from '@ant-design/icons';
import { api_uploadOPTcsv } from '../api/uploadExcel';
import { ColDef, GridOptions, themeQuartz } from 'ag-grid-community';
import CustomLoadingOverlay from '../components/CustomLoadingOverlay';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { api_updateOpt, LoadOptList } from '../api/loadOPTList';
import { on } from 'events';

const HeaderStyle: React.CSSProperties = {
    height: '50px',
};

export function isLoadOptListResponse(result: LoadOptListResult): result is LoadOptListResponse {
    return result.success === true; 
}

export function isUpdateOptResult(result: UpdateOptResult): result is UpdateOptResponse {
    return result.success === true; 
}

const OPTins: React.FC = () => {

    const [loading, setLoading] = useState(false)
    const [rowData, setRowData] = useState<OPTinsData[]>([]);
    const [optlist, setOptList] = useState<OPTinsData[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const listRef = useRef(optlist);
    const gridRef = useRef<AgGridReact>(null);

    const [colDefs, setColDefs] = useState<ColDef[]>([
        {
            headerName: 'ImportDate', field: "ImportDate", width: 120, resizable: true,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        {
            headerName: 'DateOfPayment', field: "DateOfPayment", width: 120, resizable: true,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        { headerName: 'EntityName', field: "EntityName", width: 180, resizable: true },
        { headerName: 'NAICCode', field: "NAICCode", width: 90, resizable: true },
        { headerName: 'EntityType', field: "EntityType", width: 250, resizable: true },
        { headerName: 'FEIN', field: "FEIN", width: 100, resizable: true, cellStyle: { textAlign: "right" } },
        { headerName:'NPN', field: "NPN", width: 80, resizable: true, cellStyle: { textAlign: "right" }, 
            editable: (params: any) => { return params.data?.Invaild === false} 
        },
        { headerName:'StateID', field: "StateID", width: 100, resizable: true, cellStyle: { textAlign: "right" }, 
            editable: (params: any) => { return params.data?.Invaild === false} 
        },
        { headerName:'SubmitterName', field: "SubmitterName", width: 140, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'FilingTrackingNumber', field: "FilingTrackingNumber", width: 160, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'FilingPeriod', field: "FilingPeriod", width: 120, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'FilingYear', field: "FilingYear", width: 100, resizable: true, cellStyle: { textAlign: "right" }},
        {
            headerName: 'SLTD', field: "SLTD", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_92', field: "PayCode_92", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_42', field: "PayCode_42", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_03', field: "PayCode_03", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_49', field: "PayCode_49", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_26', field: "PayCode_26", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_Q1', field: "PayCode_Q1", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_Q2', field: "PayCode_Q2", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_Q3', field: "PayCode_Q3", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_Q4', field: "PayCode_Q4", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_SLT91', field: "PayCode_SLT91", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_SLT', field: "PayCode_SLT", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_30', field: "PayCode_30", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_SDTRD', field: "PayCode_SDTRD", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_Refund92', field: "PayCode_Refund92", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_Refund03', field: "PayCode_Refund03", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_Refund42', field: "PayCode_Refund42", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'PayCode_Refund49', field: "PayCode_Refund49", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'Amount', field: "Amount", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'AdditionalPayments', field: "AdditionalPayments", width: 80, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        { headerName:'TransactionNumber', field: "TransactionNumber", width: 140, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'TransactionType', field: "TransactionType", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'TransactionDetail', field: "TransactionDetail", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'TransactionStatus', field: "TransactionStatus", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'StateIDFound', field: "StateIDFound", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'Notes', field: "Notes", width: 300, resizable: true, cellStyle: { textAlign: "right" }},
    ]);

    useEffect(() => {
        listRef.current = optlist;
    }, [optlist]);


    useEffect(() => {
        onLoadOptList();
    }, []);

    const defaultColDef = useMemo<ColDef>(() => {
        return {
            headerClass: 'custom-header',
            sortable: false,
        };
    }, []);

    const myTheme = themeQuartz
        .withParams({
            headerColumnBorder: { color: 'gray' },
            headerColumnBorderHeight: '90%',
        });

    const onCellValueChanged = (params: any) => {

        console.log(`call onCellValueChanged: ${params.oldValue} ${params.colDef.field}`)

        const updateRow = optlist[params.rowIndex]
        updateRow.StateID = params.data.StateID
        updateRow.NPN = params.data.NPN

        api_updateOpt(updateRow)
        .then((response) => {
            if (response.success) {
            if (isUpdateOptResult(response)) {
                const updateList = [...optlist];
                updateList[params.rowIndex] = response.newOpt
                setOptList(updateList);
                //setRowData(convertToRowFiling(updatedfilinglist, slcodes))
                const rowNode = gridRef.current!.api.getDisplayedRowAtIndex(params.rowIndex)
                rowNode?.setData(response.newOpt)
            }
            }
            else {
                if ("errorMsg" in response) {
                    message.error(response.errorMsg)
                }
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        });
    };

    const onCellDoubleClicked = (params: any) => {

    };

    const isValidate = (data: any) => {
        return true
    }
  
  const handleImportCSV = async () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
      fileInputRef.current.click(); // Trigger file input click
    }
  };
  
  const handleUploadError = (error: unknown): void => {
    console.error('Error:', error instanceof Error ? error.message : error);
    message.error({ content: 'Failed to upload.', key: 'uploadCSV', duration: 2 });
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', 'false');

    try {
      message.loading({ content: 'Uploading...', key: 'uploadCSV', duration: 0 });
      const response = await api_uploadOPTcsv(formData);

      if (response.success) {
        message.success({ content: 'Upload successful!', key: 'uploadCSV', duration: 2 });
        setOptList([])
        setRowData([])
        onLoadOptList()
      } else {
        message.error({ content: `Upload failed: ${response.errorMsg}`, key: 'uploadCSV', duration: 4 });
      }
      
    } catch (error) {
        handleUploadError(error);
    }
  };

    const gridOptions: GridOptions = {
        rowClassRules: {
            'row-red': params => params.data?.Invaild === false
        }
    };

    
    const onLoadOptList = () => {
        setLoading(true)
        LoadOptList()
        .then((optResult) => {

            if (optResult.success) {
                //message.success({ content: 'Successfully loaded Filing History', key: 'historyStatus', duration: 2  });
                if (isLoadOptListResponse(optResult)) {
                    // console.log(`Load OPT list success, ${JSON.stringify(optResult.optlist)}`);
                    setOptList(optResult.optlist)
                    setRowData(optResult.optlist)
                }
            }
            else {
                message.error({ content: 'Failed to load the OPT list', key: 'historyStatus', duration: 2 });
                if ("errorMsg" in optResult) {
                    message.error(optResult.errorMsg)
                }
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        })
        .finally(() => {
            setLoading(false)
        });
    }

  return (
    <div style={{ height: '100%' }} className='text-style'>
        <div className="flex items-center bg-gray-100" style={HeaderStyle}>
            <div className='flex'>
                <Button
                variant="outlined"
                type='primary'
                onClick={handleImportCSV}
                icon={<ImportOutlined className='icon-style' />}
                className={`ml-10 button-style`}>
                ImportCSV
            </Button>
            <input
                    ref={fileInputRef}
                    type="file"
                    accept=".csv"
                    style={{ display: 'none' }} // Hide the file input
                    onChange={handleFileChange}
                />
            </div>
            <div className='flex flex-row ml-10 text-xs'>
                <div><span>The red-highlighted rows have an incorrect License Number.</span></div>
            </div>
            
        </div>
        <div className="ag-theme-alpine  tab-container">
            <AgGridReact
                ref={gridRef}
                rowData={rowData}
                gridOptions={gridOptions}
                columnDefs={colDefs}
                theme={myTheme}
                defaultColDef={defaultColDef}
                headerHeight={35}
                rowHeight={25}
                onCellValueChanged={onCellValueChanged}
                onCellDoubleClicked={onCellDoubleClicked}
                loading={loading}
                loadingOverlayComponent={CustomLoadingOverlay}
                loadingOverlayComponentParams={{ message: 'Loading...' }}

            />
        </div>
    </div>
  );
};

export default OPTins;
